import { EnvironmentConfig } from './env-config';

export const environment: EnvironmentConfig = {
	type: 'development',
	production: false,
	identityPlatformTenantId: 'operator-users-ll5mg',
	firebase: {
		apiKey: "AIzaSyBza_z3LVB541JGKmVlFjTPn7gst1uYTg8",
		authDomain: "gobubble-a1364.firebaseapp.com",
		databaseURL: "https://gobubble-a1364.firebaseio.com",
		projectId: "gobubble-a1364",
		storageBucket: "gobubble-a1364.appspot.com",
		messagingSenderId: "866851378406",
		appId: "1:866851378406:web:692464977fc22ebba05727",
		measurementId: "G-BX97TW9TPS"
	},
	graphqlUrl: 'https://api-dev.internal.omnita.ai/operator/graphql',
	graphqlApiKey: 'AIzaSyBza_z3LVB541JGKmVlFjTPn7gst1uYTg8',
};
